import * as React from "react"
import { cn } from "@/lib/utils"

const SkipLink = React.forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement>
>(({ className, children = "Skip to main content", ...props }, ref) => {
  return (
    <a
      ref={ref}
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50",
        "bg-background text-foreground px-4 py-2 rounded-md shadow-lg",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        className
      )}
      href="#main-content"
      {...props}
    >
      {children}
    </a>
  )
})
SkipLink.displayName = "SkipLink"

export { SkipLink }
